import { gql } from "__generated__"

export const GET_USER_REQUEST_STATISTIC_DETAILS = gql(`
  query GetUserRequestStatisticDetails(
    $userId: Int!
    $action: RequestLeaveAction!
    $status: RequestLeaveStatus
    $fromDate: String!
    $toDate: String!
  ) {
    getUserRequestStatisticDetails(
      userId: $userId
      action: $action
      status: $status
      fromDate: $fromDate
      toDate: $toDate
    ) {
      id
      action
      status
      startDate
      endDate
      reason
      note
      amount
    }
  }
`)

export const GET_USER_REQUEST_STATISTICS = gql(`
  query GetUserRequestStatistics($fromDate: String!, $toDate: String!) {
    getUserRequestStatistics(fromDate: $fromDate, toDate: $toDate) {
      userId
      name
      fullName
      employeeCode
      leave {
        total
        awaitingApproval
        approved
        rejected
      }
      remote {
        total
        awaitingApproval
        approved
        rejected
      }
      leaveEarly {
        total
        awaitingApproval
        approved
        rejected
      }
      late {
        total
        awaitingApproval
        approved
        rejected
      }
    }
  }
`)
